import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Handshake, CheckCircle2, Briefcase, Users, Shield, TrendingUp, Building2, Home } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
export function PartnerPage() {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries()) as Record<string, string>;
    // Envoyer via Web3Forms (email à contact@adcc.africa)
    const result = await sendViaWeb3Forms({
      type: 'partenariat',
      fields: data
    });
    console.log('📋 Partenariat submission result:', result);
    setIsLoading(false);
    setSubmitted(true);
  };
  if (submitted) {
    return <Layout data-id="element-1555">
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4" data-id="element-1556">
          <Card className="max-w-md w-full text-center p-8 shadow-xl border-t-4 border-t-[#1E88E5]" data-id="element-1557">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1558">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-1559" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1560">
              Demande de partenariat envoyée !
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-1561">
              Merci de votre confiance. Notre équipe chargée des relations
              employeurs va étudier votre demande et vous recontactera dans les
              plus brefs délais pour échanger sur vos besoins.
            </p>
            <Button onClick={() => window.location.reload()} className="w-full" data-id="element-1562">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-1563">
      <SEO {...pageSEO.partner} data-id="element-1564" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16 md:py-24" data-id="element-1565">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1566">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-1567">
            Devenir Employeur Partenaire
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1568">
            Recrutez avec l'ADCC
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1569">
            Accédez à un vivier de talents qualifiés, formés et accompagnés pour
            répondre à vos besoins en personnel de maison, hôtellerie et
            services.
          </p>
        </div>
      </div>

      {/* Avantages du Partenariat */}
      <section className="py-20 bg-gray-50" data-id="element-1570">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1571">
          <div className="text-center mb-12" data-id="element-1572">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1573">
              Pourquoi Recruter via l'ADCC
            </span>
            <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-4" data-id="element-1574">
              Les avantages d'un partenariat avec l'ADCC
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1575">
              Des compétences avérées, des emplois dignes, un accompagnement sur
              mesure.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1576">
            {[{
            icon: Briefcase,
            title: 'Personnels Qualifiés et Certifiés',
            desc: 'Accédez à des profils formés professionnellement avec certification reconnue. Compétences techniques et relationnelles validées.'
          }, {
            icon: Shield,
            title: 'Cadre Éthique et Transparent',
            desc: "Recrutement dans le respect des droits, conditions claires, contrats formalisés. Sensibilisation aux bonnes pratiques d'emploi."
          }, {
            icon: Users,
            title: 'Accompagnement Personnalisé',
            desc: 'Matching précis selon vos besoins, préparation du personnel avant placement, intégration facilitée.'
          }, {
            icon: TrendingUp,
            title: 'Suivi Post-Placement',
            desc: 'Accompagnement continu après recrutement, médiation en cas de besoin, garantie de durabilité de la relation professionnelle.'
          }].map((benefit, index) => <Card key={index} className="bg-white" data-id="element-1577">
                <CardContent className="p-8 flex gap-6" data-id="element-1578">
                  <div className="flex-shrink-0" data-id="element-1579">
                    <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center" data-id="element-1580">
                      <benefit.icon className="w-7 h-7 text-[#1E88E5]" data-id="element-1581" />
                    </div>
                  </div>
                  <div data-id="element-1582">
                    <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1583">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-1584">
                      {benefit.desc}
                    </p>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-20 bg-white" data-id="element-1585">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1586">
          <div className="text-center mb-16" data-id="element-1587">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1588">
              Comment ça marche ?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-1589">
              Un processus simple et transparent pour un recrutement réussi.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative" data-id="element-1590">
            {/* Ligne de connexion (desktop) */}
            <div className="hidden md:block absolute top-8 left-12 right-12 h-0.5 bg-gray-200 z-0" data-id="element-1591"></div>

            {[{
            step: '1',
            title: '1. Expression du besoin',
            desc: 'Vous remplissez le formulaire détaillant vos attentes et le profil recherché.'
          }, {
            step: '2',
            title: '2. Sélection',
            desc: 'Nous identifions les candidats les plus adaptés parmi nos bénéficiaires certifiés.'
          }, {
            step: '3',
            title: '3. Rencontre',
            desc: "Organisation d'entretiens avec les profils présélectionnés."
          }, {
            step: '4',
            title: '4. Intégration',
            desc: "Signature du contrat et suivi régulier de l'intégration."
          }].map((item, index) => <div key={index} className="relative z-10 text-center" data-id="element-1592">
                <div className="w-16 h-16 bg-[#1E88E5] text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-1593">
                  {item.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1594">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1595">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Formulaire */}
      <section className="py-20 bg-white" data-id="element-1596">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1597">
          <Card data-id="element-1598">
            <CardContent className="p-8" data-id="element-1599">
              <div className="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100" data-id="element-1600">
                <div className="p-3 bg-blue-50 rounded-full" data-id="element-1601">
                  <Handshake className="w-8 h-8 text-[#1E88E5]" data-id="element-1602" />
                </div>
                <div data-id="element-1603">
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-1604">
                    Formulaire de partenariat
                  </h2>
                  <p className="text-gray-500 text-sm" data-id="element-1605">
                    Devenez employeur partenaire et recrutez des personnels
                    qualifiés
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1606">
                <div data-id="element-1607">
                  <label htmlFor="partnerType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1608">
                    Type de partenaire *
                  </label>
                  <select id="partnerType" name="partnerType" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border bg-white" data-id="element-1609">
                    <option value="" data-id="element-1610">Sélectionnez...</option>
                    <option value="famille" data-id="element-1611">Famille (particulier)</option>
                    <option value="entreprise" data-id="element-1612">Entreprise</option>
                    <option value="institution" data-id="element-1613">Institution / ONG</option>
                  </select>
                </div>

                <div data-id="element-1614">
                  <label htmlFor="orgName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1615">
                    Nom de l'organisation / Famille *
                  </label>
                  <input type="text" id="orgName" name="orgName" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Ex: Hôtel Azalaï ou Famille Dupont" data-id="element-1616" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1617">
                  <div data-id="element-1618">
                    <label htmlFor="responsibleName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1619">
                      Nom du contact *
                    </label>
                    <input type="text" id="responsibleName" name="responsibleName" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Votre nom" data-id="element-1620" />
                  </div>
                  <div data-id="element-1621">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1622">
                      Téléphone *
                    </label>
                    <input type="tel" id="phone" name="phone" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="+229..." data-id="element-1623" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1624">
                  <div data-id="element-1625">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1626">
                      Email *
                    </label>
                    <input type="email" id="email" name="email" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="votre@email.com" data-id="element-1627" />
                  </div>
                  <div data-id="element-1628">
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1629">
                      Ville / Quartier *
                    </label>
                    <input type="text" id="address" name="address" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Ex: Cotonou, Haie Vive" data-id="element-1630" />
                  </div>
                </div>

                <div data-id="element-1631">
                  <label htmlFor="needs" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1632">
                    Vos besoins en recrutement *
                  </label>
                  <textarea id="needs" name="needs" required rows={4} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Quels types de profils recherchez-vous ? (Cuisinier, Nounou, Réceptionniste...)" data-id="element-1633"></textarea>
                </div>

                <Button type="submit" className="w-full text-lg py-6" disabled={isLoading} data-id="element-1634">
                  {isLoading ? 'Envoi en cours...' : 'Envoyer la demande'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>;
}